var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("common-layout", [_c("div", {
    staticClass: "top"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.systemName))])])]), _c("div", {
    staticClass: "login"
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      rules: _vm.rules,
      model: _vm.loginForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "useraccount"
    }
  }, [_c("a-input", {
    attrs: {
      autocomplete: "autocomplete",
      size: "large",
      placeholder: _vm.$t("login.useraccountPH")
    },
    model: {
      value: _vm.loginForm.useraccount,
      callback: function callback($$v) {
        _vm.$set(_vm.loginForm, "useraccount", $$v);
      },
      expression: "loginForm.useraccount"
    }
  }, [_c("a-icon", {
    attrs: {
      slot: "prefix",
      type: "user"
    },
    slot: "prefix"
  })], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "password"
    }
  }, [_c("a-input", {
    attrs: {
      size: "large",
      placeholder: _vm.$t("login.pwdPH"),
      autocomplete: "autocomplete",
      type: "password"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.loginForm.password,
      callback: function callback($$v) {
        _vm.$set(_vm.loginForm, "password", $$v);
      },
      expression: "loginForm.password"
    }
  }, [_c("a-icon", {
    attrs: {
      slot: "prefix",
      type: "lock"
    },
    slot: "prefix"
  })], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "code"
    }
  }, [_c("div", {
    staticStyle: {
      display: "inline-block",
      width: "32%"
    }
  }, [_c("img", {
    attrs: {
      src: _vm.codesrc
    },
    on: {
      click: _vm.showCaptcha
    }
  })]), _c("div", {
    staticStyle: {
      display: "inline-block",
      width: "68%"
    }
  }, [_c("a-input", {
    attrs: {
      size: "large",
      placeholder: _vm.$t("login.captchaPH")
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.loginForm.code,
      callback: function callback($$v) {
        _vm.$set(_vm.loginForm, "code", $$v);
      },
      expression: "loginForm.code"
    }
  })], 1)]), _c("div"), _c("a-form-model-item", [_c("a-button", {
    staticStyle: {
      width: "100%",
      "margin-top": "24px"
    },
    attrs: {
      loading: _vm.logging,
      size: "large",
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("login.login")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };